import { Link } from 'react-router-dom'
import {
  useMaintenanceSchedules,
  useUpdateSchedule,
  useDeleteSchedule,
} from '../../hooks/useMaintenance'
import { usePrinters } from '../../hooks/usePrinters'

export default function MaintenanceSchedule() {
  const { data: schedules } = useMaintenanceSchedules()
  const { data: printers } = usePrinters()
  const updateSchedule = useUpdateSchedule()
  const deleteSchedule = useDeleteSchedule()

  if (!schedules || !printers) return <div>Loading…</div>

  const byPrinter = new Map<string, typeof schedules>()
  for (const s of schedules) {
    if (!byPrinter.has(s.printer_id)) byPrinter.set(s.printer_id, [])
    byPrinter.get(s.printer_id)!.push(s)
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--space-4)' }}>
        <Link
          to="/maintenance/schedule/new"
          style={{
            padding: 'var(--space-2) var(--space-4)',
            background: 'var(--color-primary)',
            color: 'white',
            borderRadius: 'var(--radius-md)',
            fontWeight: 600,
            fontSize: 'var(--font-size-sm)',
            textDecoration: 'none',
          }}
        >
          + Add schedule
        </Link>
      </div>
      {printers.map((p) => {
        const list = byPrinter.get(p.id) ?? []
        return (
          <div key={p.id} style={{ marginBottom: 'var(--space-6)' }}>
            <h3 style={{ fontSize: 'var(--font-size-base)', marginBottom: 'var(--space-2)' }}>{p.name}</h3>
            {list.length === 0 ? (
              <div style={{
                padding: 'var(--space-4)',
                background: 'var(--color-surface-2)',
                borderRadius: 'var(--radius-md)',
                color: 'var(--color-text-muted)',
                fontSize: 'var(--font-size-sm)',
              }}>
                No schedules configured for this printer.
              </div>
            ) : (
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {list.map((s) => (
                  <li key={s.id} style={{
                    background: 'var(--color-surface)',
                    padding: 'var(--space-3)',
                    borderRadius: 'var(--radius-md)',
                    marginBottom: 'var(--space-2)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    opacity: s.is_active ? 1 : 0.5,
                  }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 'var(--font-size-sm)' }}>
                        {formatTask(s.task_type)}
                      </div>
                      <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-faint)' }}>
                        Every {s.interval_value} {s.interval_type}
                        {!s.is_active && ' · disabled'}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 'var(--space-2)' }}>
                      <button
                        onClick={() => updateSchedule.mutate({ id: s.id, is_active: !s.is_active })}
                        style={{ color: 'var(--color-primary)', fontSize: 'var(--font-size-xs)', fontWeight: 600 }}
                      >
                        {s.is_active ? 'Disable' : 'Enable'}
                      </button>
                      <button
                        onClick={() => {
                          if (window.confirm('Delete this schedule?')) deleteSchedule.mutate(s.id)
                        }}
                        style={{ color: 'var(--color-danger)', fontSize: 'var(--font-size-xs)' }}
                      >
                        Delete
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )
      })}
    </div>
  )
}

function formatTask(t: string): string {
  return t.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
}
